// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.waveform_container_VS2m6 {
  width: 100%;
}

.waveform_waveform-path_u8Gdu {
  /*
        This color is lighter than sound-primary, but
        cannot use alpha because of overlapping elements.
    */
  fill: hsl(300, 54%, 72%);
  stroke: var(--sound-tertiary);
}

.waveform_baseline_lltQ4 {
  stroke: var(--sound-tertiary);
}
`, "",{"version":3,"sources":["webpack://./src/components/waveform/waveform.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,WAAW;AACb;;AAEA;EACE;;;KAGG;EACH,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.container {\n  width: 100%;\n}\n\n.waveform-path {\n  /*\n        This color is lighter than sound-primary, but\n        cannot use alpha because of overlapping elements.\n    */\n  fill: hsl(300, 54%, 72%);\n  stroke: var(--sound-tertiary);\n}\n\n.baseline {\n  stroke: var(--sound-tertiary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `waveform_container_VS2m6`,
	"waveform-path": `waveform_waveform-path_u8Gdu`,
	"waveformPath": `waveform_waveform-path_u8Gdu`,
	"baseline": `waveform_baseline_lltQ4`
};
export default ___CSS_LOADER_EXPORT___;
